import { EAccessSystem } from 'shared/types/filters/advanced/accessSystem';

export const mapAccessSystemLabel = {
  [EAccessSystem.WithAccessSystem]: 'По пропускам',
  [EAccessSystem.WithoutAccessSystem]: 'Свободный',
};
